import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    backButton: {
        color: 'white',
        marginLeft: '20px',
        height: '30px',
        fontSize: '12.5px',
    },
    icon: {
        marginRight: '5px',
    },
}));
